import { Grid, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { CustomTable } from 'esocial.web.react.lib/cjs/components/util/Table';
import { TituloSecao } from 'esocial.web.react.lib/cjs/components/util/Text';
import { Fragment } from 'react';

function Episv_S_01_01_00Consulta(props) {
    return (
        <Fragment>
            <TituloSecao variant="h6" variantMapping={{ h6: 'h3' }}>Equipamento Proteção Individual - EPI</TituloSecao>

            <Grid item style={{ flexBasis: '100%' }}>
                <CustomTable>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">Documento Avaliação</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.listaEpis.map((linha, indice) => (
                            <TableRow key={indice}>
                                <TableCell align="center">{linha.documentoAvaliacao}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </CustomTable>
            </Grid>
        </Fragment >
    );
}

export default Episv_S_01_01_00Consulta;
